import {Component} from "@angular/core";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {ProjectService} from "../../project/project.service";
import {ProjectModel, projectGqlModelFac, projectModelFactory} from "../../project/project.model";
import * as moment from "moment";
import {WorkflowStep} from "../workflow-step";
import {WorkflowService} from "../workflow.service";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {ListEditorService} from "../../list-editor/list-editor.service";
import {cloneDeep, isEqual} from "lodash";
import {exposeComponentInDebugMode} from "../../misc/expose-component-in-debug-mode.decorator";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {afterRun} from "../../misc/after-run.decorator";
import {ProjectOffHoldDialogComponent} from "../project/project-off-hold-dialog.component";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {FindCustomerITSMDialogComponent} from "../project/project-details-find-customer-dialog.component";
import {CountryModel} from "../../types/country";
import {Subscription} from "rxjs/Subscription";
import {AppSettingsService} from "../../app-settings/app-settings.service";
import {DartDealService} from "../../deal-list/dart-deals.service";
import {toggleLoading} from "../../misc/loading.decorator";
import {CustomerService} from "../../customer/customer-service";
import {ProjectCustomerErrorMessagesDialogComponent} from "../../project/project-customer-error-messages-dialog.component";
import {FindCustomerOpportunityGroupITSMDialogComponent} from "../project/project-details-find-customer-opportunity-group.component";
import {GlobalDealSettingsModel, globalDealSettingsModelFactory} from "../../global-deal-settings/global-deal-settings.model";
import {CustomerOpportunityGroupListResponse, GlobalDealSettingsService} from "../../global-deal-settings/global-deal-settings.service";
import "../project/spinner.scss";
import {CustomerOpportunityGroupModel} from "../../global-deal-settings/customer-opportunity-group.model";
import { GSI_DAAS_TARGET_SYSTEMS,GSI_MCS_TARGET_SYSTEMS, TARGET_SYSTEM } from "../../helpers/app-constants";
import {Query} from "../../graphql/query-constant";
import { HasuraGraphqlService } from "../../graphql/hasura-graphql-service";

const Moment: any = (moment as any).default || moment;

@Component({
  selector: "project-details",
  templateUrl: "./project-details-daas.template.pug",
  providers: [
    ProjectService,
    DartDealService,
    CustomerService,
    GlobalDealSettingsService,
    HasuraGraphqlService,
  ],
})
@exposeComponentInDebugMode()
export class ProjectDetailsDaasComponent extends WorkflowStep {
  public projectId: any;
  public project: ProjectModel = projectModelFactory();
  public globalDealSettings: GlobalDealSettingsModel = globalDealSettingsModelFactory();
  public originalProject: ProjectModel = projectModelFactory(); // Just for Dirty Checks
  public error: Error;
  public partnerPurchaseOrders: string;
  public onHoldMessage: string = null;
  public targetSystem: string;
  public countries: CountryModel[] = [];
  private subscription: Subscription;
  private customerResellerSubscription: Subscription;
  public customerState: number;
  public customerMessage: string;
  public customerErrorMessages: any[];
  public resellerErrorMessages: any[];
  public resellerState: number;
  public resellerMessage: string;
  public doneCustomerOpportunityGroup: boolean = false;
  public enableCostCenterFileDropdown: boolean = false;
  public customerSet: boolean = false;
  public canUpdateEndCustomerData: boolean = false;
  public enableMS4CustomerRefresh: boolean = false;
  public spinRefreshMS4Button: boolean = false;
  public loadingCOGName: boolean = false;
  public resellerSet: boolean = false;
  public enableCostCenters: boolean = false;
  public customerChanged: boolean = false;
  public enableTaxNumberSearch: boolean;
  public createOpportunityInItsm = false;
  public createGlobalOpportunityInItsm = false;
  public existingCogName: string;
  public customerReseller = {
    resellerName: "",
    resellerBpId: "",
    itsmResellerId: "",
    customerName: "",
    customerBpId: "",
    itsmCustomerId: "",
  };

  public enableIndirectDataModel: boolean;
  public enableGlobalDeals: boolean;
  isFileDownloading = false;
  public enableGsiDaas: boolean;
  public labelcustomerName = "Customer";
  public doneReseller: boolean = false;
  public doneCustomer: boolean = false;
  public showReseller: boolean = false;
  public enableChannelDaas: boolean;
  public POR709_TMC: boolean;
  public POR777_1_TMC: boolean;

  public navigate(queryParams: Params): Promise<boolean> {
    return this.router.navigate(["project-edit"], {queryParams});
  }

  private async getProject(): Promise<ProjectModel> {
    let enableApolloProjectQuery = await this.appSettingsService.getFeaturePermission(
      "enableApolloProjectQuery",
      this.projectId,
    );

    /*if (enableApolloProjectQuery) {
      let params: any = `
    id
    countryId
    countryName
    startDate
    fleetId
    fleetName
    customerName
    holdDate
    status
    itsmCustomerId
    name
    partnerPurchaseOrders
    dashboardIssues
    expenses
    dashboardMilestones
    qualityChecklist
    installationInstructions
    customerBpId
    resellerName
    resellerBpId
    opportunityId
    uniqueId
    sourceDocumentationLink
    customerKickoffDate
    estimatedCompletionDate
    estimatedProjectClosureDate
    actualProjectClosureDate
    estimatedTransitionDate
    actualTransitionDate
    enableBulkOrdering
    totalCustomerValue
    requireMaiPagecounts
    currency
    customerPin
    sourceName
    deliveryInformation
    workspaces
    firstInstallDate
    firstOrderDate
    isFedLLC
    `;
      return this.projectService.getProjectDetails(this.projectId, params);
    }*/
    if (enableApolloProjectQuery) {
      Query.PROJECT.variables.projectId = this.projectId;
      const queryParam = {
        projectId: this.projectId,
        query: Query.PROJECT,
        uiAction: "PROJECT",
      };
      const projHasuraResp = await this.hasuraGqlService.getResponseFromHasura(queryParam);
      const finalResponse = projectGqlModelFac(projHasuraResp);
      return finalResponse;
    } else {
      return this.projectService.getProjectById(this.projectId).toPromise();
    }
  }

  async validateNotEmptyDartDeals(projectName) {
    const dartDealsCount = await this.dartDealService.getDartDealsCount(this.workflowTargetInfo.projectId);
    if (dartDealsCount.count === 0) {
      throw new Error(`${projectName} must have a DART Deal.`);
    }
  }

  @handleErrors()
  @toggleLoading("loadingCOGName")
  private async setCogNameByOpportunityId() {
    let listCogs: CustomerOpportunityGroupListResponse = { rows: [], count: 0 };

    try {
      listCogs = await this.globalDealSettingsService.listCustomerOpportunityGroups(
        { globalOpportunityId: this.globalDealSettings.globalOpportunityId ? this.globalDealSettings.globalOpportunityId : this.project.opportunityId },
        this.projectId,
        this.targetSystem,
      );
    } catch (error) {
      //Ignore the error
    }

    if (listCogs.rows.length > 0) {
      const {customerOpportunityGroupName = "", customerOpportunityGroupId = ""}: CustomerOpportunityGroupModel = listCogs.rows[0];
      this.globalDealSettings.customerOpportunityGroupName = customerOpportunityGroupName;
      this.globalDealSettings.customerOpportunityGroupId = customerOpportunityGroupId;
      this.globalDealSettings = await this.globalDealSettingsService.saveGlobalDealSettings({
        projectId: this.projectId,
        customerOpportunityGroupName,
        customerOpportunityGroupId
      });
      this.doneCustomerOpportunityGroup = true;
      this.enableCostCenterFileDropdown = true;

      this.existingCogName = customerOpportunityGroupName;

      if (this.globalDealSettings.globalOpportunityId) {
        this.createGlobalOpportunityInItsm = false;
        var listCogsLocalOpp = await this.globalDealSettingsService.listCustomerOpportunityGroups(
          { globalOpportunityId: this.project.opportunityId },
          this.projectId, this.targetSystem);
        if (listCogsLocalOpp.rows.length === 0) {
          this.createOpportunityInItsm = true;
        }
      }
    } else {
      if (this.globalDealSettings.globalOpportunityId) {
        this.createGlobalOpportunityInItsm = true;
      }
      this.createOpportunityInItsm = true;
    }
  }

  private async subscribeCustomerReseller() {
    try {
      const observable = this.customerService.getCustomerResellerStatus(this.projectId);

      if (this.customerResellerSubscription && !this.customerResellerSubscription.closed) {
        this.customerResellerSubscription.unsubscribe();
      }
      await new Promise(() => {
        this.customerResellerSubscription = observable.subscribe((result: any) => {
          if (this.project) {
            this.project.customerBpId = result.customerBpId;
            this.project.customerName = result.customerName;
            this.project.resellerName = result.resellerName;
            this.project.resellerBpId = result.resellerBpId;
          }
          this.customerState = result.customerState;
          this.customerMessage = result.customerMessage;
          this.customerErrorMessages = result.customerErrorMessages;
          this.resellerState = result.resellerState;
          this.resellerMessage = result.resellerMessage;
          this.resellerErrorMessages = result.resellerErrorMessages;
          if (result.customerState === 2) {
            this.customerSet = true;
            if (!this.enableGlobalDeals) {
              this.enableCostCenterFileDropdown = true;
            }
          }
        });
      }).catch((error) => {
        const errorMessage = (error.length === 1) ?
          (error[0].message || "Unknown Error Message") :
          "Customer / Reseller Error(s)";
        throw new Error(errorMessage);
      });
    } catch (e) {
      throw new Error("An unexpected error occurred trying to get the reseller or customer status");
    }
  }

  @afterRun((self) => { self.loading = false; })
  @handleErrors()
  async loadData(): Promise<void> {

    const featurePermissions = await this.appSettingsService.getFeaturePermissionsList(["enableMS4CustomerRefresh", "enableGlobalDeals", "enableTaxNumberSearch", "POR373", "POR373_TMC", "POR624", "POR624_TMC", "POR709_TMC", "POR777-1_TMC", "enableCostCenters", "enableIndirectDataModel"]);
    
    this.enableMS4CustomerRefresh =featurePermissions["enableMS4CustomerRefresh"];
    this.loading = true;
    let por373 = false, por373_TMC = false;
    let por624 = false, por624_TMC = false;

    [this.enableGlobalDeals, this.enableTaxNumberSearch, por373, por373_TMC, por624, por624_TMC, this.POR709_TMC, this.POR777_1_TMC, this.enableCostCenters,this.enableIndirectDataModel] = [
      featurePermissions["enableGlobalDeals"],
      featurePermissions["enableTaxNumberSearch"],
      featurePermissions["POR373"],
      featurePermissions["POR373_TMC"],
      featurePermissions["POR624_TMC"],
      featurePermissions["POR624"],
      featurePermissions["POR709_TMC"],
      featurePermissions["POR777-1_TMC"],
      featurePermissions["enableCostCenters"],
      featurePermissions["enableIndirectDataModel"]
    ];
    this.enableGsiDaas = por373 || por373_TMC;
    this.enableChannelDaas = por624 || por624_TMC;

    const arrayPromises: Promise<any>[] = [
      this.getProject(),
    ];

    if(this.enableGsiDaas || this.enableChannelDaas || this.POR709_TMC || this.POR777_1_TMC){
      this.labelcustomerName = [TARGET_SYSTEM.DAAS, TARGET_SYSTEM.CHANNEL_DAAS, TARGET_SYSTEM.MIGRATION_CHANNEL_DAAS, TARGET_SYSTEM.MANAGED_COLLABORATION_SERVICES, TARGET_SYSTEM.MCS_SELL_THROUGH, TARGET_SYSTEM.SELL_THROUGH, TARGET_SYSTEM.MIGRATION_SELL_THROUGH, TARGET_SYSTEM.DIGITAL_SERVICE].includes(this.targetSystem) ? 'End Customer' 
      : ((this.targetSystem === TARGET_SYSTEM.SELL_WITH || this.targetSystem === TARGET_SYSTEM.BILL_THROUGH ||
        this.targetSystem === TARGET_SYSTEM.MIGRATION_SELL_WITH || this.targetSystem === TARGET_SYSTEM.MIGRATION_BILL_THROUGH || 
        this.targetSystem === TARGET_SYSTEM.MCS_SELL_WITH || this.targetSystem === TARGET_SYSTEM.MCS_BILL_THROUGH) ? 'Sold-To': 'Customer');
      
      this.showReseller = (this.enableGsiDaas && GSI_DAAS_TARGET_SYSTEMS.includes(this.targetSystem)) || (this.POR709_TMC && GSI_MCS_TARGET_SYSTEMS.includes(this.targetSystem)) || [TARGET_SYSTEM.CHANNEL_DAAS, TARGET_SYSTEM.MIGRATION_CHANNEL_DAAS].includes(this.targetSystem);
    }

    if (this.enableGlobalDeals) {
      arrayPromises.push(this.globalDealSettingsService.getGlobalDealSettings(this.projectId));
    }
    const [project, globalDealSettings = {}] = await Promise.all(arrayPromises);

    this.globalDealSettings = globalDealSettings;

    if (!project.countryId) project.countryId = "";
    await this.validateNotEmptyDartDeals(project.name);

    this.project = project;
    this.doneCustomer = !!project.customerName;
    if(this.enableGsiDaas){
      this.doneReseller = GSI_DAAS_TARGET_SYSTEMS.includes(this.targetSystem) || [TARGET_SYSTEM.CHANNEL_DAAS, TARGET_SYSTEM.MIGRATION_CHANNEL_DAAS].includes(this.targetSystem)? !!project.resellerName: true;
    }    
    this.doneCustomerOpportunityGroup =
      !!globalDealSettings.customerOpportunityGroupName && !!globalDealSettings.customerOpportunityGroupId;
    this.originalProject = cloneDeep(this.project);
    this.customerSet = !!this.project.itsmCustomerId;
    this.subscribeCustomerReseller(); // we don't await this because it'll never finish

    if (this.enableGlobalDeals) {
        this.setCogNameByOpportunityId();
    }

    if (this.project.holdDate) {
      const MS_PER_DAY = 24 * 60 * 60 * 1000;
      const now = new Date();
      const holdDate = new Date(this.project.holdDate);
      const timeOnHold = now.getTime() - holdDate.getTime();
      this.onHoldMessage = (timeOnHold < MS_PER_DAY) ?
        `Project has been on hold ${((timeOnHold * 10 / MS_PER_DAY) / 10).toFixed(1)} day(s)` :
        `Project has been on hold ${Math.ceil(timeOnHold / MS_PER_DAY)} day(s)`;
    }

    if ((this.project.resellerName && this.project.resellerName.trim().length > 0) ||
      this.workflowService.getCurrentStepStatus() === WorkflowStepStatus.InProgress) {
      this.project.includeReseller = true;
    }

    if (!project.status) {
      project.status = "open";
    }

    this.resellerSet = !!this.project.resellerName.trim();

    this.canUpdateEndCustomerData = this.customerSet;


    if (this.project.resellerName && this.project.resellerBpId) {
      this.customerReseller.resellerName = this.project.resellerName;
      this.customerReseller.resellerBpId = this.project.resellerBpId;
    }
    if (this.project.customerName && this.project.customerBpId) {
      this.customerReseller.customerName = this.project.customerName;
      this.customerReseller.customerBpId = this.project.customerBpId;
      this.customerReseller.itsmCustomerId = this.project.itsmCustomerId;
    }

    if (this.enableGlobalDeals) {
      if (this.doneCustomerOpportunityGroup) {
        this.enableCostCenterFileDropdown = true;
      }
    } else {
      this.enableCostCenterFileDropdown = this.customerSet;
    }
  }
  public customerSearchBy:string = 'name';
  checkCustomerSearchBy(type:string){
    this.customerSearchBy = type;
    this.project.customerName = '';
  }

  public resellerSearchBy: string = 'name';
  checkResellerSearchBy(type: string) {
    this.resellerSearchBy = type;
    this.project.resellerName = '';
  }

  ready() {
    this.error = undefined;
    this.projectId = this.workflowService.workflowConfig.targetId;
    this.targetSystem = this.workflowService.workflowConfig.targetSystem;
    this.loadData();
  }

  constructor(
    private projectService: ProjectService,
    private customerService: CustomerService,
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    private listEditorService: ListEditorService,
    private dialogService: DialogService,
    private appSettingsService: AppSettingsService,
    private dartDealService: DartDealService,
    private globalDealSettingsService: GlobalDealSettingsService,
    private hasuraGqlService: HasuraGraphqlService,
  ) {
    super(true);
  }

  @toggleLoading()
  @handleErrors()
  async autoSave(): Promise<boolean> {
    this.error = undefined;

    if ((this.enableGsiDaas && !this.project.resellerName && !this.doneReseller) || 
    (this.enableGsiDaas && this.project.resellerName && !this.doneReseller) ||
    (this.enableChannelDaas && !this.project.resellerName && !this.doneReseller) ||
    (this.enableChannelDaas && this.project.resellerName && !this.doneReseller)) {
      throw new Error("Reseller Name is required");
    }

    if ((!this.project.customerName && !this.doneCustomer) || (this.project.customerName && !this.doneCustomer)) {
      throw new Error(this.labelcustomerName + " Name is required");
    }
    
    if (
      this.enableGlobalDeals &&
      ((!this.globalDealSettings.customerOpportunityGroupName && !this.doneCustomerOpportunityGroup) ||
      (this.globalDealSettings.customerOpportunityGroupName && !this.doneCustomerOpportunityGroup))
    ) {
      throw new Error("Customer Opportunity Group is required");
    }

    if (this.originalProject.status === "hold" && this.project.status !== "hold") {
      const incrementResult = await this.dialogService.showDialog(
        ProjectOffHoldDialogComponent,
        {message: this.onHoldMessage, projectName: this.project.name},
        {backdropColor: "rgba(0, 0, 0, 0.5)"},
      );

      if (incrementResult) {
        if (incrementResult.increment > 0) {
          await this.projectService.saveProject({
            ...this.project,
            estimatesIncrement: incrementResult,
          });
          await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
          return true;
        }
        // Else fall bask to the normal save outside this if block
      } else {
        // Return back to the parent screen
        return false;
      }
    }

    if (!this.createOpportunityInItsm && (this.globalDealSettings.customerOpportunityGroupName !== this.existingCogName)) {
      this.createOpportunityInItsm = true;
    }

    await this.projectService.saveProject(this.project, {
      createGlobalOpportunityInItsm: this.createGlobalOpportunityInItsm,
      createOpportunityInItsm: this.createOpportunityInItsm
    });

    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
    if (this.workflowService.readableTargetName !== this.project.name) {
      await this.workflowService.updateWorkflowConfig(this.workflowService.workflowConfig.id);
    }

    return true;
  }

  cancel(): void {
    this.router.navigate(["projects"]);
  }

  checkDirty(): boolean {
    return !isEqual(this.project, this.originalProject);
  }

  onStatusChange() {
    this.project.actualProjectClosureDate = "";
    if (this.project.status === "closed") {
      this.project.actualProjectClosureDate = Moment().format("YYYY-MM-DD");
    }
    this.project.actualDeploymentCompletionDate = "";
    if (this.project.status === "steady") {
      this.project.actualDeploymentCompletionDate = Moment().format("YYYY-MM-DD");
    }
  }

  @toggleLoading()
  @handleErrors()
  async searchCustomerName(isReseller = false) {
    const dataToSearch = isReseller ? this.project.resellerName : this.project.customerName;
    const isCustomerSearchChecked = isReseller ? this.resellerSearchBy : this.customerSearchBy;
    const result = await FindCustomerITSMDialogComponent.showFindCustomerITSMDialogModal(
      this.dialogService,
      {
        customerName: dataToSearch,
        projectId: this.projectId,
        isReseller: isReseller,
        targetSystem: this.targetSystem,
        customerSearchBy: isCustomerSearchChecked
      },
    );
    if (isReseller == false && result.customerSearchBy) {
      this.customerSearchBy = result.customerSearchBy;
    }
    if (isReseller == false && result.customerName) {
      this.project.customerName = result.customerName;
    }
    if (isReseller == true && result.customerSearchBy) {
      this.resellerSearchBy = result.customerSearchBy;
    }
    if (isReseller == true && result.customerName) {
      this.project.resellerName = result.customerName;
    }
    if (result && result.selectedCustomerInfo) {
      this.loading = true;


      // update the UI with the results
      this.customerChanged = !!(
        this.project.itsmCustomerId &&
        result.selectedCustomerInfo.customerId &&
        result.selectedCustomerInfo.customerId !== this.project.itsmCustomerId &&
        !isReseller
      );

      const field = isReseller ? "reseller" : "customer";
      this.project[`${field}Name`] = result.selectedCustomerInfo.customerName;
      this.project[`${field}BpId`] = result.selectedCustomerInfo.bpid;
      this.project[`itsm${field[0].toUpperCase() + field.slice(1)}Id`] = result.selectedCustomerInfo.customerId;
      this.customerReseller[`${field}Name`] = result.selectedCustomerInfo.customerName;
      this.customerReseller[`${field}BpId`] = result.selectedCustomerInfo.bpid;
      this.customerReseller[`itsm${field[0].toUpperCase() + field.slice(1)}Id`] = result.selectedCustomerInfo.customerId;
      this.customerState = 0;
      this.resellerState = 0;

      // update the UI with the results
      if (isReseller)
        this.doneReseller = true;
      else
        this.doneCustomer = true;
    }

    if (((GSI_DAAS_TARGET_SYSTEMS.includes(this.targetSystem))) || (GSI_MCS_TARGET_SYSTEMS.includes(this.targetSystem)) ||
    (this.enableChannelDaas && ([TARGET_SYSTEM.CHANNEL_DAAS, TARGET_SYSTEM.MIGRATION_CHANNEL_DAAS].includes(this.targetSystem)))) {
      if (this.project.resellerName && this.project.customerName) {
        await this.projectService.setMs4ItsmAddress(
          this.projectId,
          isReseller,
          this.enableIndirectDataModel ? this.customerReseller : result.selectedCustomerInfo,
        );
      }
    } else if (this.project.customerName) {
      await this.projectService.setMs4ItsmAddress(
        this.projectId,
        isReseller,
        result.selectedCustomerInfo,
      );
    }

    this.loading = false;
  }

  async updateEndCustomerData() {
    this.spinRefreshMS4Button = true;
    if (GSI_DAAS_TARGET_SYSTEMS.includes(this.targetSystem) || GSI_MCS_TARGET_SYSTEMS.includes(this.targetSystem) ||
    [TARGET_SYSTEM.CHANNEL_DAAS, TARGET_SYSTEM.MIGRATION_CHANNEL_DAAS].includes(this.targetSystem)) {
      await this.projectService.setMs4ItsmAddress(this.projectId, false, {
        customerBpId: this.project.customerBpId,
        resellerBpId: this.project.resellerBpId,
        itsmResellerId: this.project.resellerCustomerId,
        itsmCustomerId: this.project.itsmCustomerId
      }, true);
    }
    else {
      const customerProjectInfo = await this.customerService.listMs4Customers(this.project.customerBpId, this.projectId, false, 'bpid');
      if (customerProjectInfo.rows.length) {
        await this.projectService.setMs4ItsmAddress(
          this.projectId,
          false,
          customerProjectInfo.rows[0],
          true,
        );
      }
    }
    this.spinRefreshMS4Button = false;
  }

  @toggleLoading()
  @handleErrors()
  async searchCustomerOpportunityGroup() {
    const result = await FindCustomerOpportunityGroupITSMDialogComponent.showFindOpportunityGroupITSMDialogModal(
      this.dialogService,
      {
        customerOpportunityGroupName: this.globalDealSettings.customerOpportunityGroupName,
        projectId: this.projectId,
        targetSystem: this.targetSystem,
        globalOpportunityId: this.globalDealSettings.globalOpportunityId,
      },
    );

    if (result && result.selectedCustomerOpportunityGroupInfo) {
      const {
        customerOpportunityGroupId,
        customerOpportunityGroupName,
        leadEndCustomerAccountId: leadCustomerItsmId,
      } = result.selectedCustomerOpportunityGroupInfo;

      if (result.customerOpportunityGroupCreated) {
        this.globalDealSettings.customerOpportunityGroupId = customerOpportunityGroupId;
        this.globalDealSettings.customerOpportunityGroupName = customerOpportunityGroupName;
        this.globalDealSettings.leadCustomerItsmId = leadCustomerItsmId;
      } else {
        this.globalDealSettings = await this.globalDealSettingsService.saveGlobalDealSettings({
          projectId: this.projectId,
          customerOpportunityGroupId,
          customerOpportunityGroupName,
          leadCustomerItsmId,
        });
      }

      this.doneCustomerOpportunityGroup = true;
      this.enableCostCenterFileDropdown = true;
    }
  }

  showErrorMessages(customer = true) {
    const data = customer ? {errorMessages: this.customerErrorMessages} :
      {errorMessages: this.resellerErrorMessages};
    ProjectCustomerErrorMessagesDialogComponent.showDialog(
      this.dialogService,
      data,
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.subscription = this.appSettingsService.countries.subscribe((countries) => {
      this.countries = countries;
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }

    if (this.customerResellerSubscription && !this.customerResellerSubscription.closed) {
      this.customerResellerSubscription.unsubscribe();
    }
  }
}
